import { cn } from '@mntn-dev/ui-utilities'

import { Skeleton } from '../../skeleton/skeleton.tsx'

export type TagSkeletonProps = {
  className?: string
}

export const TagSkeleton = ({ className }: TagSkeletonProps) => {
  return <Skeleton className={cn('w-16 h-5 rounded-full', className)} />
}
